package com.partejar.app.core.ui.components

import androidx.compose.animation.animateColorAsState
import androidx.compose.animation.core.tween
import androidx.compose.foundation.BorderStroke
import androidx.compose.foundation.interaction.MutableInteractionSource
import androidx.compose.foundation.interaction.collectIsPressedAsState
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.PaddingValues
import androidx.compose.foundation.layout.heightIn
import androidx.compose.foundation.layout.padding
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Surface
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.remember
import androidx.compose.ui.Modifier
import com.partejar.app.core.ui.theme.PartejarTheme

@Composable
fun PartejarCard(
    modifier: Modifier = Modifier,
    contentPadding: PaddingValues = PaddingValues(PartejarTheme.spacing.space16),
    content: @Composable () -> Unit
) {
    PartejarCardSurface(modifier = modifier) {
        Box(modifier = Modifier.padding(contentPadding)) {
            content()
        }
    }
}

@Composable
fun PartejarCard(
    onClick: () -> Unit,
    modifier: Modifier = Modifier,
    enabled: Boolean = true,
    contentPadding: PaddingValues = PaddingValues(PartejarTheme.spacing.space16),
    motionEnabled: Boolean = false,
    content: @Composable () -> Unit
) {
    val dimensions = PartejarTheme.dimensions
    val interactionSource = remember { MutableInteractionSource() }
    val pressed by interactionSource.collectIsPressedAsState()
    val containerColor by animateColorAsState(
        targetValue = if (pressed) {
            MaterialTheme.colorScheme.surfaceContainerHigh
        } else {
            MaterialTheme.colorScheme.surfaceContainerLow
        },
        animationSpec = if (motionEnabled) tween(
            durationMillis = if (pressed) PartejarMotion.press else PartejarMotion.release,
            easing = PartejarMotion.calm
        ) else tween(durationMillis = 120),
        label = "partejarCardContainer"
    )

    Surface(
        onClick = onClick,
        modifier = modifier.heightIn(min = dimensions.minimumTouchTarget)
            .then(if (motionEnabled) Modifier.partejarPressFeedback(pressed, enabled) else Modifier),
        enabled = enabled,
        shape = MaterialTheme.shapes.large,
        color = containerColor,
        contentColor = MaterialTheme.colorScheme.onSurface,
        border = BorderStroke(
            dimensions.strokeThin,
            MaterialTheme.colorScheme.outline.copy(alpha = 0.62f)
        ),
        interactionSource = interactionSource
    ) {
        Box(modifier = Modifier.padding(contentPadding)) {
            content()
        }
    }
}

@Composable
private fun PartejarCardSurface(
    modifier: Modifier,
    content: @Composable () -> Unit
) {
    val dimensions = PartejarTheme.dimensions

    Surface(
        modifier = modifier,
        shape = MaterialTheme.shapes.large,
        color = MaterialTheme.colorScheme.surfaceContainerLow,
        contentColor = MaterialTheme.colorScheme.onSurface,
        border = BorderStroke(
            dimensions.strokeThin,
            MaterialTheme.colorScheme.outline.copy(alpha = 0.62f)
        ),
        content = content
    )
}
